function r(t = 8) {
  return Math.random().toString(16).slice(2, 2 + t);
}
export {
  r as createId
};
